import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddTenantUomNameMutationVariables = Types.Exact<{
  input: Types.AddTenantUomNameInput;
}>;


export type AddTenantUomNameMutation = { __typename?: 'Mutation', addTenantUomName: { __typename?: 'TenantUomListPayload', names?: Array<string> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AddTenantUomNameDocument = new TypedDocumentString(`
    mutation AddTenantUomName($input: AddTenantUomNameInput!) {
  addTenantUomName(input: $input) {
    names
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddTenantUomName: build.mutation<AddTenantUomNameMutation, AddTenantUomNameMutationVariables>({
      query: (variables) => ({ document: AddTenantUomNameDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddTenantUomNameMutation } = injectedRtkApi;
